import { fetch } from '@/plugin/axios/index.js'
import formAxios from '@/plugin/axios/formAxios.js'


/**
 * 计划列表
 * @param {Object} data
 */
export function getPageList(data) {
  return fetch({
    url: '/sale/telemarketing/plan/pageList',
    method: 'POST',
    data
  })
}

/**
 * 计划项目列表
 * @param {Object} data
 */
export function getProjectPageList(data) {
  return fetch({
    url: '/sale/telemarketing/plan/projectPageList',
    method: 'POST',
    data
  })
}




/**
 * 合同回款导出
 * @param {Object} data
 */
export function exportContractCollection(data) {
  return formAxios({
    url: '/financial/collection/employee/export',
    method: 'POST',
    data
  })
}


/**
 * 计划删除
 * @param {Object} data
 */
export function deleteData(data) {
  return fetch({
    url: '/sale/telemarketing/plan/delete',
    method: 'POST',
    data
  })
}


/**
 * 电销项目详情
 * @param {Object} data
 */
export function getProjectDetail(params) {
  return fetch({
    url: '/sale/telemarketing/plan/projectDetail',
    method: 'GET',
    params
  })
}

/**
 * 电销项目编辑
 * @param {Object} data
 */
export function saveTelemarketingItem(data) {
  return fetch({
    url: '/sale/telemarketing/plan/saveTelemarketingItem',
    method: 'POST',
    data
  })
}

/**
 * 电销项目编辑
 * @param {Object} data
 */
export function saveTelemarketingMessage(data) {
  return fetch({
    url: '/sale/telemarketing/plan/saveTelemarketingMessage',
    method: 'POST',
    data
  })
}


/**
 * 添加附件
 * @param {Object} data
 */
export function addTelemarketingFile(data) {
  return fetch({
    url: '/sale/telemarketing/plan/addTelemarketingFile',
    method: 'POST',
    data
  })
}

/**
 * 删除附件
 * @param {Object} data
 */
export function deleteTelemarketingFile(data) {
  return fetch({
    url: '/sale/telemarketing/plan/deleteTelemarketingFile',
    method: 'POST',
    data
  })
}

/**
 * 合同回款列表
 * @param {Object} data
 */
export function realList(data) {
  return fetch({
    url: '/financial/collection/contract/real/list',
    method: 'POST',
    data
  })
}


/**
 * 创建合同回款
 * @param {Object} data
 */
export function createContractCollection(data) {
  return fetch({
    url: '/financial/collection/contract/create',
    method: 'POST',
    data
  })
}


/**
 * 删除合同回款
 * @param {Object} data
 */
export function deleteContractCollection(data) {
  return fetch({
    url: '/financial/collection/real/remove',
    method: 'POST',
    data
  })
}




// WEBPACK FOOTER //
// ./src/api/salesManagement/dxjh.js